var map = {
	"./chinaInternational/route.js": "./src/routes/new-router/chinaInternational/route.js",
	"./doc/route.js": "./src/routes/new-router/doc/route.js",
	"./home/route.js": "./src/routes/new-router/home/route.js",
	"./migrate-to-welink/route.js": "./src/routes/new-router/migrate-to-welink/route.js",
	"./numberBlueSky/route.js": "./src/routes/new-router/numberBlueSky/route.js",
	"./shanghaiInstituteofTechnology/route.js": "./src/routes/new-router/shanghaiInstituteofTechnology/route.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/routes/new-router sync recursive route.js$";